import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Brand: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Brand',
  minWidth: 150,
  maxWidth: 280,
  accessorFn: (product) => product.brand,
});
